'use client';
import {
  FC,
  ReactNode,
  createContext,
  useContext,
  useState,
  useRef,
  useEffect,
} from 'react';
import { Lenis as ReactLenis } from '@studio-freight/react-lenis';

const options = {};

interface IContext {
  disableBodyScroll: () => void;
  enableBodyScroll: () => void;
}

const LenisContext = createContext<IContext>({
  disableBodyScroll: () => {},
  enableBodyScroll: () => {},
});

export const useLenis = () => {
  return useContext(LenisContext);
};

interface Props {
  children: ReactNode;
}

const SmoothScroll: FC<Props> = ({ children }) => {
  const [autoRaf, setAutoRaf] = useState(true);
  const lenisRef = useRef<typeof ReactLenis>();

  const disableBodyScroll = () => {
    setAutoRaf(false);
    lenisRef?.current?.lenis?.stop();
  };

  const enableBodyScroll = () => {
    setAutoRaf(true);
    lenisRef?.current?.lenis?.start();
  };

  useEffect(() => {
    const pageLayout = document.querySelector('#app');

    if (pageLayout) {
      const resizeObserver = new ResizeObserver(() => {
        lenisRef?.current?.lenis?.resize();
        window.dispatchEvent(new Event('resize'));
      });

      resizeObserver.observe(pageLayout);
    }
  }, []);

  return (
    <LenisContext.Provider value={{ disableBodyScroll, enableBodyScroll }}>
      <ReactLenis
        ref={lenisRef}
        className={'lenis-container'}
        autoRaf={autoRaf}
        root
        options={{ ...options }}>
        {children}
      </ReactLenis>
    </LenisContext.Provider>
  );
};

export default SmoothScroll;
